import type { Maybe, Nullable } from '@nova/core';
import { isEmpty, isNil, isString } from 'lodash';

/** Query key on `/tasks` for deep-linking the yard task detail dialog. */
export const YARD_TASK_DETAIL_QUERY_KEY = 'taskId';

/**
 * Normalizes a single entry from `route.query` (e.g. `route.query.taskId`).
 *
 * Vue Router parses the search string by key; the order of parameters in the URL
 * (`?a=1&taskId=x&b=2` vs `?taskId=x&a=1`) does not change the value you read for `taskId`.
 *
 * If the same key is repeated (`?taskId=&taskId=abc`), the value may be an array; this
 * returns the first non-empty string segment, or `null` if there is none.
 */
export function readYardTaskIdFromRouteQuery(
  queryValue: Maybe<string | Nullable<string>[]>
): Nullable<string> {
  if (isNil(queryValue)) {
    return null;
  }

  if (Array.isArray(queryValue)) {
    for (const segment of queryValue) {
      if (isString(segment) && !isEmpty(segment)) {
        return segment;
      }
    }

    return null;
  }

  if (isEmpty(queryValue)) {
    return null;
  }

  return queryValue;
}
